const INTERACTION_GROUP_MANIFEST = [
  {
    key: 'personal',
    label: '个人空间',
    routeKeys: ['my-file', 'my-note', 'my-exam', 'my-video'],
  },
  {
    key: 'school',
    label: '校本空间',
    routeKeys: ['school-resource', 'school-exam'],
  },
] as const;

export const INTERACTION_ROUTE_MANIFEST = [
  { key: 'my-file', label: '我的文件', path: '/workspace/interaction/my-file' },
  { key: 'my-exam', label: '我的题库', path: '/workspace/interaction/my-exam' },
  { key: 'my-video', label: '我的视频', path: '/workspace/interaction/my-video' },
  { key: 'my-note', label: '我的笔记', path: '/workspace/interaction/my-note' },
  { key: 'school-resource', label: '校本资源', path: '/workspace/interaction/school-resource' },
  { key: 'school-exam', label: '校本题库', path: '/workspace/interaction/school-exam' },
] as const;

export type InteractionRouteKey = typeof INTERACTION_ROUTE_MANIFEST[number]['key'];
export type InteractionGroupKey = typeof INTERACTION_GROUP_MANIFEST[number]['key'];

export interface InteractionRouteAccess {
  key: InteractionRouteKey;
  label: string;
  path: string;
}

export interface InteractionGroupAccess {
  key: InteractionGroupKey;
  label: string;
  routes: readonly InteractionRouteAccess[];
}

export interface InteractionAccess {
  groups?: readonly InteractionGroupAccess[];
  mode: 'bundle' | 'children' | 'denied';
  routes: readonly InteractionRouteAccess[];
}

export const deniedInteractionAccess: InteractionAccess = {
  mode: 'denied',
  routes: [],
};

/** isInteractionRouteKey 判断未知路径片段是否属于资源空间正式注册清单。 */
export function isInteractionRouteKey(value: string): value is InteractionRouteKey {
  return INTERACTION_ROUTE_MANIFEST.some(route => route.key === value);
}

/** findInteractionRoute 按规范地址查找唯一注册项，供权限解析和页面路由共同复用。 */
export function findInteractionRoute(path: string): InteractionRouteAccess | undefined {
  return INTERACTION_ROUTE_MANIFEST.find(route => route.path === path);
}

/** findInteractionGroupByRouteKey 返回注册路由所属的稳定侧栏分组。 */
export function findInteractionGroupByRouteKey(
  routeKey: InteractionRouteKey,
): typeof INTERACTION_GROUP_MANIFEST[number] | undefined {
  return INTERACTION_GROUP_MANIFEST.find(group => (
    (group.routeKeys as readonly InteractionRouteKey[]).includes(routeKey)
  ));
}

/** canAccessInteractionRoute 判断当前只读授权是否允许访问指定页面。 */
export function canAccessInteractionRoute(
  access: InteractionAccess,
  key: InteractionRouteKey,
): boolean {
  return access.routes.some(route => route.key === key);
}
